import React from 'react'
import { useTranslation } from 'react-i18next'
import { getLocalizedStatusOptions, getStatusAppearance } from '../../constants/ticket'

// شريط الحالات بعدّاداتها — مشترك بين شريط فلاتر التذاكر وصفحة المشروع.
// singleRow: كل الحالات في سطر واحد (بيتحرك أفقي لو زادت)، و children (البحث) في سطر لوحده تحته.
const TicketStatusChips = ({ lang = 'ar', statuses, activeStatus = 'all', getStatusCount, onStatusChange, children = null, singleRow = false }) => {
    const [t] = useTranslation('global');
    const statusChips = [
        { label: t('support.tickets.allStatuses'), value: 'all', bg: '#f1f5f9', color: '#334155', dot: '#64748b' },
        ...getLocalizedStatusOptions(statuses, lang).map((opt) => ({
            ...opt,
            ...getStatusAppearance(statuses, opt.value)
        }))
    ];

    const chips = statusChips.map((opt) => {
                const isActive = (activeStatus || 'all') === opt.value;
                const count = getStatusCount ? getStatusCount(opt.value) : 0;
                return (
                    <button
                        key={opt.value}
                        type="button"
                        onClick={() => onStatusChange?.(opt.value || 'all')}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            flexShrink: 0,
                            whiteSpace: 'nowrap',
                            gap: singleRow ? 6 : 8,
                            padding: singleRow ? '6px 10px' : '7px 12px',
                            borderRadius: 999,
                            border: isActive ? '1px solid #4f46e5' : '1px solid #e2e8f0',
                            background: isActive ? '#eef2ff' : '#fff',
                            cursor: 'pointer'
                        }}
                    >
                        <span style={{ width: 8, height: 8, borderRadius: 999, background: opt.dot || opt.color || '#64748b' }} />
                        <span style={{ fontSize: 12, fontWeight: 800, color: '#0f172a' }}>{opt.label}</span>
                        <span style={{
                            minWidth: 26,
                            height: 18,
                            padding: '0 8px',
                            borderRadius: 999,
                            background: opt.bg || '#f1f5f9',
                            color: opt.color || '#334155',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: 11,
                            fontWeight: 900
                        }}>
                            {count}
                        </span>
                    </button>
                );
            });

    if (singleRow) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <div className="table-scroll" style={{ display: 'flex', flexWrap: 'nowrap', gap: 6, alignItems: 'center', overflowX: 'auto', paddingBottom: 2 }}>
                    {chips}
                </div>
                {children}
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
            {chips}
            {children}
        </div>
    );
};

export default TicketStatusChips
